// extracted by mini-css-extract-plugin
module.exports = {"ctaButton":"cta-button_ctaButton__6iOMp"};